export {
  IconButton,
  type IconButtonProps,
  type IconButtonGhostProps,
  type IconButtonPrimaryAndSecondaryProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/IconButton';
